// src/components/nodes/NodePanel.js
import { nodeManager } from './NodeManager';

export const NodePanel = ({ onDragStart, isEditAllowed }) => {
  const nodeConfigs = nodeManager.getAllNodeConfigs();

  // 添加特殊节点配置
  const specialNodes = [
    { type: 'custom', label: '开始节点', icon: '🚀', defaultData: { label: '开始', icon: '🚀' } },
    { type: 'custom', label: '结束节点', icon: '✅', defaultData: { label: '结束', icon: '✅' } },
  ];

  const allNodes = [...nodeConfigs, ...specialNodes];

  return (
    <div className="node-panel">
      <h3>节点库</h3>
      {allNodes.map((node) => (
        <div
          key={`${node.type}-${node.label}`}
          className="node-item"
          draggable={isEditAllowed}
          onDragStart={(event) => onDragStart(event, node)}
          title={isEditAllowed ? '拖拽到画布添加节点' : '只读模式，无法编辑'}
        >
          <span className="node-icon">{node.icon}</span>
          <span className="node-label">{node.label}</span>
        </div>
      ))}
    </div>
  );
};